module.exports = __webpack_public_path__ + "static/media/top-menu-icon.d5c546e4.svg";